import MenuItem from './MenuItem';
export default MenuItem;
//# sourceMappingURL=index.js.map